import { ResponsivePie } from '@nivo/pie';
import { Currency } from '../../../types/common';

import { computePercentage } from '../../../helpers/functions';
import { PieCenter } from './PieCenter';
import { PieOverlay } from './PieOverlay';
import { PieShadow } from './PieShadow';
import { Center, PieData } from '../types';
import { useThemeContext } from '../../../context/Theme';

export const Pie = ({
  center,
  className,
  margin,
  pieData,
  pieColors,
  strategyValue,
  symbol,
  handlePieCenter,
  onClick = () => {},
  resetCenter,
  setCenter,
}: {
  center: Center;
  className: string;
  margin: number;
  pieData: PieData[];
  pieColors?: string[];
  strategyValue: number;
  symbol: Currency['symbol'];
  handlePieCenter(i: number): void;
  onClick?(p?: any): any;
  resetCenter(): void;
  setCenter: React.Dispatch<React.SetStateAction<Center>>;
}) => {
  const percentage = computePercentage(strategyValue, center.value);
  const { theme } = useThemeContext();

  return (
    <div className={className}>
      <PieOverlay />

      <div
        className={`
          absolute
          top-0
          bottom-0
          left-0
          right-0
          oveflow-hidden
          bg-center
          z-20
        `}
      >
        <ResponsivePie
          key={'pie'}
          data={pieData}
          // colors={pieColors}
          colors={{ datum: 'data.color' }}
          margin={{
            top: margin,
            right: margin,
            bottom: margin,
            left: margin,
          }}
          innerRadius={0.87}
          activeInnerRadiusOffset={1}
          activeOuterRadiusOffset={2.5}
          enableArcLinkLabels={false}
          enableArcLabels={false}
          tooltip={() => <></>}
          onClick={onClick}
          onMouseEnter={({ id, value }) => setCenter({ id: String(id), value })}
          onMouseLeave={() => resetCenter()}
          animate={false}
        />
      </div>

      {theme !== 'DARK' && <PieShadow />}

      <PieCenter
        handlePieCenter={handlePieCenter}
        id={center.id}
        percentage={percentage.toFixed(percentage < 100 ? 2 : 0)}
        value={center.value}
        symbol={symbol}
      />
    </div>
  );
};
